import { useMutation, useQuery } from "@tanstack/react-query";
import { loginUser, fetchMyPermissions } from "services/auth";
import { useFinancialYearStore, useAuthStore } from "store";

export const useLoginUser = () => {
  const setCurrentFinancialYear = useFinancialYearStore(
    (state) => state.setCurrentFinancialYear
  );
  const setAuthData = useAuthStore((state) => state.setAuthData);

  const query = useMutation({
    mutationKey: ["login-user"],
    mutationFn: (data) => loginUser(data),
    onSuccess: (data) => {
      setAuthData(data);
      setCurrentFinancialYear(data.financial_year);
    },
  });

  return query;
};

export const useMyPermissions = () => {
  const token = useAuthStore((state) => state.token);

  return useQuery({
    queryKey: ["my-permissions"],
    queryFn: fetchMyPermissions,
    enabled: !!token,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: true,
  });
};
